import React, { useState } from 'react'
import shortid from 'shortid'

import Button from '@react/react-spectrum/Button'
import ComboBox from '@react/react-spectrum/ComboBox'
import Select from '@react/react-spectrum/Select'
import { Table, THead, TBody, TH, TR, TD } from '@react/react-spectrum/Table'
import Textfield from '@react/react-spectrum/Textfield'

import Delete from '@react/react-spectrum/Icon/Delete'

const DATA_ELEMENTS = [
  { label: 'Page Title', value: 'pageTitle' },
  { label: 'Product Name', value: 'productName' },
  { label: 'Product Image', value: 'productImage' },
  { label: 'Product Price', value: 'productPrice' },
]

const EmptyState = () => (
  <div className='pvs-emptyState'>
    <p>No data elements</p>
  </div>
)

const addIds = arr => (Array.isArray(arr) ? arr.map(p => ({ ...p, id: shortid() })) : [])

const Editor = ({ properties, disabled, onSave }) => {
  const [entries, setEntries] = useState(addIds(properties))
  const hasEntries = Array.isArray(entries) && entries.length > 0

  const addEntry = () => {
    setEntries(entries => [...entries, { id: shortid() }])
  }

  const deleteEntry = id =>
    setEntries(entries => {
      const newEntries = entries.filter(e => e.id !== id)
      onSave(newEntries)
      return newEntries
    })

  const onFieldChange = (name, id) => value => {
    setEntries(entries => {
      const newEntries = entries.map(e => (e.id === id ? { ...e, [name]: value } : e))
      onSave(newEntries)
      return newEntries
    })
  }

  return (
    <div className='data-elements-editor'>
      {hasEntries && (
        <Table className='data-elements-table'>
          <THead>
            <TH>Name</TH>
            <TH>Dynamic value</TH>
            <TH>Fallback value</TH>
            <TH width='140'>Format as</TH>
            <TH width='60' className='pvs-actions'>
              Action
            </TH>
          </THead>
          <TBody>
            {entries.map(entry => (
              <TR key={entry.id}>
                <TD>
                  <ComboBox
                    options={DATA_ELEMENTS}
                    value={entry.name || ''}
                    placeholder='Name'
                    onChange={onFieldChange('name', entry.id)}
                    disabled={disabled}
                  />
                </TD>
                <TD>
                  <Textfield
                    defaultValue={entry.cssSelector || ''}
                    placeholder='CSS selector'
                    onClick={e => {
                      e.stopPropagation()
                    }}
                    onChange={onFieldChange('cssSelector', entry.id)}
                    disabled={disabled}
                  />
                </TD>
                <TD>
                  <Textfield
                    defaultValue={entry.fallbackValue || ''}
                    placeholder='Fallback value'
                    onClick={e => {
                      e.stopPropagation()
                    }}
                    onChange={onFieldChange('fallbackValue', entry.id)}
                    disabled={disabled}
                  />
                </TD>
                <TD>
                  <Select
                    options={[
                      { label: 'String', value: 'string' },
                      { label: 'Number', value: 'int' },
                      { label: 'Price', value: 'price' },
                    ]}
                    defaultValue={entry.formatAs || 'string'}
                    placeholder='Format as'
                    onClick={e => {
                      e.stopPropagation()
                    }}
                    onChange={onFieldChange('formatAs', entry.id)}
                    disabled={disabled}
                    className='data-elements-format-as-select'
                  />
                </TD>
                <TD>
                  <Button
                    variant='tool'
                    aria-label='Delete'
                    icon={<Delete />}
                    onClick={() => deleteEntry(entry.id)}
                    disabled={disabled}
                  />
                </TD>
              </TR>
            ))}
          </TBody>
        </Table>
      )}

      {!hasEntries && <EmptyState />}

      <Button
        label='Add Data Element'
        className='data-elements-add-button'
        variant='primary'
        onClick={addEntry}
        disabled={disabled}
      />
    </div>
  )
}

export default Editor
